import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const RoleBasedRoute = ({ element, allowedRoles }) => {
  const { user } = useUser();
  
  // If user has no roles or user's roles don't include any of the allowed roles
  if (!user || !user.roles || (allowedRoles && 
      !user.roles.some(role => allowedRoles.includes(role.name)))) {
    return <Navigate to="/dashboard" replace />;
  }
    
  return element;
};
/*
const RoleBasedRoute = ({ element, allowedRoles }) => {
  const { user } = useUser();

  const activeRoleId = user?.current_role_id ?? user?.role_id;

  const currentAllowedRoleIds = {
    learner: 4,
    admin: 1,
    author: 5,
    manager: 7,
  };

  const allowedIds = (allowedRoles || []).map((roleName) => currentAllowedRoleIds[roleName]).filter(Boolean);

  const isAllowed =
    !!user &&
    (!allowedRoles || allowedIds.includes(Number(activeRoleId)));

  if (!isAllowed) {
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};
*/
export default RoleBasedRoute;